import "./styles.css";

import React from "react";
import CalendarHeatmap from "react-calendar-heatmap";
import ReactTooltip from "react-tooltip";
import { useLocation } from "../../contexts/LocationContext";
import { getStatesNames } from "../../data";

import styles from "./HeatMap.module.css";

function HeatMap2({ month, values, startDate, endDate, empty }) {
  const location = useLocation();
  const statesNames = getStatesNames();

  function tooltipDataAttrs(value) {
    if (!empty)
      return {
        "data-tip": `${
          value.count ? value.count : 0
        } people killed by police in ${
          location === "US" ? "the U.S." : statesNames[location]
        }`,
      };
  }

  return (
    <div className={styles.chart}>
      <div className={styles.month}>{month}</div>
      <div>
        <CalendarHeatmap
          showMonthLabels={false}
          horizontal={false}
          startDate={startDate}
          endDate={endDate}
          values={values}
          classForValue={(value) => {
            if (empty) {
              return "color-empty";
            }
            if (!value) {
              return "color-empty";
            }
            return `color-github-${value.count}`;
          }}
          // titleForValue={(value) => `Date is ${value.date ? value.date : ""}`}
          tooltipDataAttrs={tooltipDataAttrs}
        />
        <ReactTooltip place="bottom" type="dark" effect="float" />
      </div>
    </div>
  );
}

export default HeatMap2;
